// Libs
import styled from 'styled-components'

// Comps.
import { Section } from '../Section'
import { P } from '../P'

// Defs
interface Props {
  className?: string
  text?: string
}

// Styles
const Container = styled(Section)`
  .large-explanation {
    width: 100%;
    max-width: 594px;
    margin: auto;
    text-align: center;
  }
`

export const LargeExplainSection: React.FC<Props> = (props) => {
  // Props
  const { className, text } = props

  // ..
  return (
    <Container className={`LargeExplainSection ${className || ''}`}>
      <P className="large-explanation">{text || ''}</P>
    </Container>
  )
}
